var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "banner-preview" }, [
    _vm.showTitle
      ? _c("div", { staticClass: "preview-title" }, [
          _vm._v(_vm._s(_vm.title) + "："),
        ])
      : _vm._e(),
    _c("div", { staticClass: "preview-container" }, [_vm._t("imgSlot")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }